<template>
  <div>

    <div class="step-info">
      <img class="step-info__icon" v-if="currentQuestion.type == 'intro'" src="../../assets/intro.png" alt="">

      <h1 class="step-info__title">{{ currentQuestion.title }}</h1>

      <div class="step-info__results row justify-content-center" v-if="currentQuestion.type == 'results'">

        <div class="col-md-3 px-0 grid-single" v-for="result in finalResults().profiles">
          <a class="d-block" :href="result.url" target="_blank">
            <img class="img-fluid" :src="result.image" alt="">
            <div class="grid-overlay">
              <p class="grid-name">{{ result.title }}</p>
              <p class="grid-detail">{{ result.cat }}</p>
              <p class="grid-link">See brand profile
                <img src="../../assets/search.svg" class="grid-icon" alt="">
              </p>
            </div>
          </a>
        </div>

      </div>

      <p class="step-info__description">{{ currentQuestion.description }}</p>

    </div>

    <div class="step-option--radio" v-if="currentQuestion.type == 'multi'">
      <div class="step-option--radio__answer" v-for="answer in currentQuestion.answers">
        <input type="radio" v-model="tempAnswer[currentQuestion.name]" :id="'label-' + answer.value" :value="answer.value">
        <label :for="'label-' + answer.value">{{ answer.name }}</label>
      </div>
    </div>

    <div class="step-option--slider" v-if="currentQuestion.type == 'slider'">
      <img class="step-option--slider__image--male" src="../../assets/male.png" alt="">
      <slider
        class="step-option--slider__slider"
        ref="slider"
        :tooltip="false"
        v-model="tempAnswer[currentQuestion.name]"
        :min="currentQuestion.range.min"
        :max="currentQuestion.range.max"
        :height="23"
        :dot-size="23"
      >
      </slider>
      <span class="step-option--slider__control">No Major Skew</span>
      <img class="step-option--slider__image--female" src="../../assets/female.png" alt="">
    </div>



    <div :class="currentQuestion.type == 'intro' || currentQuestion.type == 'results' ? 'step-buttons--center' : 'step-buttons--with-prev'">
      <div v-if="currentQuestion.type != 'intro' && currentQuestion.type != 'results'" class="step-buttons__prev" @click="prevStep()">
        <img class="step-buttons__prev__arrow" src="../../assets/back-arrow.svg" alt="">
        Previous Step
      </div>
      <button v-if="currentQuestion.type == 'results'" class="step-buttons__main--orange" @click="goHome()">Back to Home</button>
      <button class="step-buttons__main" @click="nextStep()">{{ currentQuestion.nextText }}</button>
    </div>

  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'

export default {
  name: 'Question',
  props: ['current', 'questions', 'results'],
  data () {
    return {
      tempAnswer: {}
    }
  },
  components: {
    'slider': vueSlider
  },
  computed: {
    sliderRef () {
      return this.$refs.slider
    },
    currentQuestion () {
      var question = this.questions.find(q => q.number === this.current)
      return question
    },
    answers () {
      return JSON.parse(sessionStorage.getItem('answers'))
    }
  },
  methods: {
    nextStep () {
      if (this.currentQuestion.type === 'results') {
        this.goContact()
      } else {
        this.$router.push({ name: 'Survey Step', params: { step: this.current + 1 } })
      }
      if (this.currentQuestion.updateAnswer){
        this.$emit('updated', this.tempAnswer)
      }
    },
    prevStep () {
      this.$router.push({ name: 'Survey Step', params: { step: this.current - 1 } })
    },
    finalResultString () {
      var age = this.answers['target']
      var gender = ''
      if (this.answers['gender'] <= 30) {
        gender = 'M'
      } else if (this.answers['gender'] >= 60) {
        gender = 'F'
      } else {
        gender = 'N'
      }
      return age + gender
    },
    finalResults () {
      var results = this.results[0].find(t => t.title === this.finalResultString())
      return results
    },
    goHome () {
      window.location.href = '/'
    },
    goContact () {
      window.location.href = '/contact'
    }
  },
  mounted () {
    this.$set(this.tempAnswer, this.currentQuestion.name, this.answers[this.currentQuestion.name])
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/survey/Question.vue